var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.09 70.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #996875;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #efd3d9;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.05,
    cy: 35.05,
    r: 35.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.99,28.46l9.53,9.53c.56.56,1.33.87,2.12.87s1.54-.31,2.1-.87l9.53-9.53c.89-.89,1.09-2.21.61-3.29-.13-.49-.38-.95-.77-1.34-1.17-1.15-3.04-1.14-4.19.03l-2.97,3.01c-1.16,1.17-2.7,1.82-4.35,1.83-1.65-.04-3.2-.63-4.36-1.8l-3.05-3.05c-1.16-1.16-3.04-1.16-4.19,0-.63.63-.91,1.48-.85,2.31-.06.83.21,1.67.85,2.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.1,36.53c-1.17-1.15-3.04-1.14-4.19.03l-2.97,3.01c-1.16,1.17-2.7,1.82-4.35,1.83h-.02c-1.64,0-3.18-.64-4.34-1.8l-3.05-3.05c-1.16-1.16-3.04-1.16-4.19,0-.63.63-.91,1.48-.85,2.31-.06.83.21,1.67.85,2.31l9.53,9.53c.56.56,1.33.87,2.12.87s1.54-.31,2.1-.87l9.53-9.53c.89-.89,1.09-2.21.61-3.29-.13-.49-.38-.95-.77-1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTone);
export default __webpack_public_path__ + "static/media/DownTone.1ae809a8a024a982a7e4b6ea2876bff4.svg";
export { ForwardRef as ReactComponent };